import { create } from 'zustand';

interface DrawerState {
  open: boolean;
}

interface DrawerActions {
  setOpen(open: boolean): void;
  toggle(): void;
}

export const useDrawerStore = create<DrawerState & DrawerActions>()(set => ({
  open: true,
  setOpen(open) {
    set(() => ({ open }));
  },
  toggle() {
    set(state => ({ open: !state.open }));
  },
}));
